import styles from './index.module.scss';
import { Parser } from '@phi/util/types';
import { defineComponent, h, PropType } from 'vue';
import { I } from '@vaaas/fpts/combinator';
import { Autocomplete } from '../types';

export type Type =
    'text'
    | 'email'
    | 'password';

type Variant =
    'default'
    | 'outlined';

export const FormText = defineComponent({
    name: 'FormText',

    props: {
        value: {
            required: true,
            type: null as any as PropType<string | undefined>,
        },

        placeholder: {
            required: false,
            type: String,
        },

        change: {
            required: false,
            type: Boolean,
            default: false,
        },

        disabled: {
            required: false,
            type: Boolean,
            default: false,
        },

        parser: {
            required: false,
            type: Function as PropType<Parser<string>>,
            default: I,
        },

        select_all_on_focus: {
            required: false,
            type: Boolean,
            default: false,
        },

        type: {
            required: false,
            type: String as PropType<Type>,
            default: 'text',
        },

        variant: {
            required: false,
            type: String as PropType<Variant>,
            default: 'default',
        },

        name: { required: false, type: String },

        autocomplete: { required: false, type: String as PropType<Autocomplete> },
    },

    emits: {
        'update:value': (x: string) => true,
    },

    methods: {
        update(x: InputEvent) {
            const value = this.parser((x.target as HTMLInputElement).value);
            if (!(value instanceof Error))
                this.$emit('update:value', value);
        },

        do_nothing() { return; },

        on_focus() {
            if (this.select_all_on_focus)
                this.$el.select();
        },
    },

    render() {
        return h('input', {
            name: this.name,
            class: {
                'form-text': true,
                [styles.input]: true,
                [styles.outlined]: this.variant === 'outlined',
            },
            type: this.type,
            value: this.value,
            onInput: this.change ? this.do_nothing : this.update,
            onChange: this.change ? this.update : this.do_nothing,
            onFocus: this.on_focus,
            placeholder: this.placeholder,
            disabled: this.disabled,
            autocomplete: this.autocomplete,
        });
    }
});
